import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { VehicleControlComponent } from './vehicle-control.component';
import { VehicleControlRoutingModule } from './vehicle-control-rounting.module';

@NgModule({
  declarations: [VehicleControlComponent],

  imports: [SharedModule, VehicleControlRoutingModule,],
})
export class VehicleControlModule {}
